import { motion } from "framer-motion";

export const MaskLineInView = ({ children, delay = 0 }) => (
  <motion.span className="block" initial="h" whileInView="v" viewport={{ once: true, amount: 0.1 }}>
    <span className="block overflow-hidden pb-[0.06em]">
      <motion.span
        className="block"
        variants={{ h: { y: "105%" }, v: { y: "0%" } }}
        transition={{ duration: 1, delay, ease: [0.2, 0.7, 0.1, 1] }}
      >
        {children}
      </motion.span>
    </span>
  </motion.span>
);
